import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { ReactComponent as SecondDepth } from '../../assets/icon/common/icon__second-depth.svg';
import { ReactComponent as ThirdDepth } from '../../assets/icon/common/icon__third-depth.svg';

const PrimaryStyle = css`
  font-size: ${boTheme.font.size.title};
  font-weight: ${boTheme.font.weight.bold};
  color: ${boTheme.color.sub1};
  line-height: 100%;
`;

const SecondaryStyle = css`
  ${PrimaryStyle};
  font-size: ${boTheme.font.size.medium};
`;

const ThirdStyle = css`
  ${PrimaryStyle};
  font-size: ${boTheme.font.size.basic};
`;

const styleMap = {
  primary: PrimaryStyle,
  secondary: SecondaryStyle,
  third: ThirdStyle,
  basic: ThirdStyle,
};

const StyledTitle = styled(TextBox)`
  ${({ type }) => styleMap[type]}
`;

export const ContentTitle = ({ type, children }) => {
  return (
    <StyledTitle type={type}>
      {type === 'secondary' && <SecondDepth style={{ paddingRight: '6px' }} />}
      {type === 'third' && <ThirdDepth style={{ paddingRight: '6px' }} />}
      {children}
    </StyledTitle>
  );
};

ContentTitle.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary', 'third', 'basic']),
  children: PropTypes.node,
};

ContentTitle.defaultProps = {
  type: 'primary',
};
